import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-base-image-resources';

@Injectable({
  providedIn: 'root'
})
export class BaseImageService {

  constructor(private fabricService: FabricService) {}

  getBaseImageUpdates(id: string, size?: number): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_base-image-updates', {id, size});
  }

  getCurrentBaseImageUpdate(id: string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_base-image-updates_latest', {id});
  }

  getBaseImageUpdateById(id: string, baseImageUpdateId: string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_base-image-updates_baseimageupdateid', {id, baseImageUpdateId});
  }

  createBaseImageUpdate(id: string, params: any): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_instances_id_base-image-updates', {id, ...params});
  }

  rollbackBaseImageUpdate(id: string, baseImageUpdateId: string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_instances_id_base-image-updates_baseimageupdateid_rollback', {id, baseImageUpdateId});
  }

}
